export enum IconButtonType {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  OUTLINE = "outline",
  GHOST = "ghost",
  ICON = "icon-btn",
}

export enum IconButtonSize {
  L = "l",
  M = "m",
  S = "s",
}
